<template>
  <div class="bg-white  padding border-radius">
    <div>
      <el-button v-if="cityAreaTreeInfo.curCityArea.areaLevel != '303'" type="primary" size="small"
        @click="openAddCityAreaModal">
        {{ $t('cityArea.add') }}
      </el-button>
      <el-button v-if="cityAreaTreeInfo.curCityArea.areaCode != '0'" type="warning" size="small"
        @click="openEditCityAreaTreeModel">
        {{ $t('cityArea.edit') }}
      </el-button>
      <el-button v-if="cityAreaTreeInfo.curCityArea.areaCode != '0'" type="danger" size="small"
        @click="openDeleteCityAreaTreeModel">
        {{ $t('cityArea.delete') }}
      </el-button>
    </div>
    <div class="margin-top">
      <el-tree ref="areaTree" :data="cityAreaTreeInfo.orgs" node-key="id" :props="defaultProps"
        @node-click="handleNodeClick"></el-tree>
    </div>

    <add-city-area ref="addCityArea" @success="loadCityAreaTrees"></add-city-area>
    <edit-city-area ref="editCityArea" @success="loadCityAreaTrees"></edit-city-area>
    <delete-city-area ref="deleteCityArea" @success="loadCityAreaTrees"></delete-city-area>
  </div>
</template>

<script>
import { queryAreaTree } from '@/api/shop/cityAreaApi'
import AddCityArea from '@/components/shop/addCityArea/addCityArea'
import EditCityArea from '@/components/shop/editCityArea/editCityArea'
import DeleteCityArea from '@/components/shop/deleteCityArea/deleteCityArea'

export default {
  name: 'CityAreaTree',
  components: {
    AddCityArea,
    EditCityArea,
    DeleteCityArea
  },
  props: {
    callBackListener: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cityAreaTreeInfo: {
        orgs: [],
        curCityArea: {}
      },
      defaultProps: {
        children: 'children',
        label: 'text'
      }
    }
  },
  mounted() {
    this.loadCityAreaTrees()
  },
  methods: {
    loadCityAreaTrees() {
      queryAreaTree().then(response => {
        this.cityAreaTreeInfo.orgs = [response.data]
      }).catch(error => {
        console.error('获取地区树失败:', error)
      })
    },
    handleNodeClick(data) {
      this.cityAreaTreeInfo.curCityArea = data
      this.$emit('switchCityAreaTree', {
        id: data.id,
        areaCode: data.areaCode,
        areaLevel: data.areaLevel,
        areaName: data.text
      })
    },
    openAddCityAreaModal() {
      if (!this.cityAreaTreeInfo.curCityArea.id) {
        this.$message.warning(this.$t('cityArea.selectAreaFirst'))
        return
      }

      let areaLevel = this.cityAreaTreeInfo.curCityArea.areaLevel
      if (areaLevel === '101') {
        areaLevel = '202'
      } else if (areaLevel === '202') {
        areaLevel = '303'
      } else if (areaLevel === '303') {
        this.$message.warning(this.$t('cityArea.cannotAddChild'))
        return
      } else {
        areaLevel = '101'
      }

      this.$refs.addCityArea.open({
        parentAreaCode: this.cityAreaTreeInfo.curCityArea.areaCode,
        areaLevel: areaLevel,
        parentAreaName: this.cityAreaTreeInfo.curCityArea.text
      })
    },
    openEditCityAreaTreeModel() {
      if (!this.cityAreaTreeInfo.curCityArea.id) {
        this.$message.warning(this.$t('cityArea.selectAreaFirst'))
        return
      }
      this.$refs.editCityArea.open(this.cityAreaTreeInfo.curCityArea)
    },
    openDeleteCityAreaTreeModel() {
      if (!this.cityAreaTreeInfo.curCityArea.id) {
        this.$message.warning(this.$t('cityArea.selectAreaFirst'))
        return
      }
      this.$refs.deleteCityArea.open(this.cityAreaTreeInfo.curCityArea)
    }
  }
}
</script>

<style scoped>
.bg-white {
  background: #fff;
}

.margin-top-xs {
  margin-top: 10px;
}

.padding {
  padding: 15px;
}

.border-radius {
  border-radius: 4px;
}

.margin-top {
  margin-top: 15px;
}
</style>